import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

export const CargoSelectionDialogStyledContainer = styled(Dialog)`
  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;
  }
`;

export const CargoSelectionStyledContainer = styled('div')`
  position: relative;
  padding: 20px 30px 30px;
  gap: 15px;
  display: flex;
  flex-flow: column;
  width: 100%;

  .cargo-list {
    margin-top: 0;
  }

  .MuiTypography-h2 {
    font-size: 26px;
  }

  .cargo-inputs-block {
    display: flex;
    flex-wrap: wrap;
    gap: 13px 22px;
    margin: 24px 0;

    > .MuiTextField-root {
      flex: 1;
      min-width: clamp(80px, calc(100% / 3 - 60px), 100%);
    }

    .MuiSelect-icon {
      font-size: 18px !important;
      fill: #383838;
    }

    .MuiInput-input {
      color: rgb(56, 56, 56) !important;
      text-align: right !important;
      font-size: 12px !important;
      font-style: normal !important;
      font-weight: 600 !important;
      line-height: 22px !important;
      padding: 4px 5px;
    }

    .MuiSelect-select {
      padding-right: 24px;
    }
  }

  .pallet-edit-control {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .pallet-edit-button {
    color: #fff;
    font-weight: 600;
    font-size: 16px;
  }
`;
